import React from "react";
import logo from "../../../assets/app-only/images/logo.png";

const Brand: React.FC = () => (
  <a className="auth-cover-brand" style={{ textDecoration: 'none' }}>
    <img src={logo} alt="CoHostZone" className="app-brand-logo" style={{ height: 48, width: 'auto' }} />
  </a>
);

export default Brand;
